import React from 'react';
import { Button } from './Button';
import './Footer.css';
import { Link } from 'react-router-dom';


function Footer() {
  return (
    <div className='footer-container'>
        <section className='footer-subscription'>
            <p className='footer-subscription-heading'>
            We provide services 7 days a week and all official holidays.
            </p>
            <p className='footer-subscription-text'>
              Monday–Friday from 9am to 5:30pm
              <br/>
              Saturday from 9am to 12:30pm
            </p>
        </section>

{/* 
        <div class='footer-links'>
          <div className='footer-link-wrapper'>
            <div class='footer-link-items'>
              <h2>About Us</h2>
              <Link to='/about'>Who are us?</Link>
              <Link to='/'>Testimonials</Link> 
              <Link to='/'>Careers</Link> 
              <Link to='/'>Terms of Service</Link> 
            </div>
          </div>
          <div className='footer-link-wrapper'>
            <div class='footer-link-items'>
              <h2>Contact Us</h2>
              <Link to='/contact'>Contact</Link>
              <Link to='/'>Instagram</Link>
              <Link to='/'>Facebook</Link>
            </div>
      </div>
    </div>
*/}
        
          <section class='social-media'>
            <div class='social-media-wrap'>
          <div class='footer-logo'>
            <Link to='/' className='social-logo'>
              TRVL
              <i class='fab fa-typo3' />
            </Link>
          </div>
          <small class='website-rights'>K2RG © 2024</small>

{/*
          <div class='social-icons'>
            <Link
              class='social-icon-link facebook'
              to='/'
              target='_blank'
              aria-label='Facebook'
            >
              <i class='fab fa-facebook-f' />
            </Link>
            <Link
              class='social-icon-link instagram'
              to='/'
              target='_blank'
              aria-label='Instagram'
            >
              <i class='fab fa-instagram' />
            </Link>
            <Link
              class='social-icon-link twitter'
              to='/'
              target='_blank'
              aria-label='LinkedIn'
            >
              <i class='fab fa-linkedin' />
            </Link>
          </div>
 */}          
        </div>
      </section>
    </div>
  )
}

export default Footer